import React from "react";
import PropTypes from "prop-types";

import propTypes from "../../../../../constants/propTypes";
import ProjectAddressGrid from "./ProjectAddressGrid";

// Edit and delete functionality removed - addresses are now read-only from property
const RenderedField = ({ rows }) => {
  return <ProjectAddressGrid rows={rows} />;
};
RenderedField.propTypes = {
  rows: PropTypes.arrayOf(propTypes.remitAddress),
};

export default RenderedField;
